module.exports = __webpack_public_path__ + "static/img/platform.36802f93.png";